import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { aplicarNomenclatura, parseNomenclatura } from './utils/nomenclatura';

import en from './locales/en';
import es from './locales/es';
import pt from './locales/pt';

const resources = {
  en: { translation: en },
  es: { translation: es },
  pt: { translation: pt },
};

// Nomenclatura do cliente (branding do tenant): produto/produtor/mesa → ex.: "Case"/"Cooperativa"/"Sala";
// null = termos padrão.
// Só atua em pt — en/es mantêm os termos originais.
let termosNomenclatura = null;

const nomenclaturaPostProcessor = {
  type: 'postProcessor',
  name: 'nomenclatura',
  process: (value) =>
    termosNomenclatura && (i18n.language || '').startsWith('pt')
      ? aplicarNomenclatura(value, termosNomenclatura)
      : value,
};

// Chamado quando o branding do tenant carrega/muda (nomenclaturaJson ou null).
export function definirNomenclatura(json) {
  const novos = parseNomenclatura(json);
  if (JSON.stringify(novos) === JSON.stringify(termosNomenclatura)) return;
  termosNomenclatura = novos;
  // Reemite languageChanged pro react-i18next re-renderizar as traduções.
  if (i18n.isInitialized) i18n.changeLanguage(i18n.language);
}

i18n
  .use(initReactI18next)
  .use(nomenclaturaPostProcessor)
  .init({
    resources,
    postProcess: ['nomenclatura'],
    lng: window.localStorage.getItem('konq.idioma') || 'pt',
    fallbackLng: 'pt',
    load: 'languageOnly', // strip region code: 'en-US' → 'en', 'pt-BR' → 'pt'
    interpolation: {
      escapeValue: false,
    },
  });
